import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import App from './App.vue'

/**
 * Vue HTTP Status Checker Tool Entry Point
 * 
 * Finds all shortcode mount points on the page and creates
 * independent Vue app instances for each.
 */

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApps)
} else {
  initializeApps()
}

function initializeApps() {
  // Find all HTTP checker shortcode mount points
  const mountPoints = document.querySelectorAll('div[id^="cnfltd-http-checker-"]')
  
  if (mountPoints.length === 0) {
    console.warn('[Conflated Domains] No HTTP checker shortcode mount points found')
    return
  }

  console.log(`[Conflated Domains] Found ${mountPoints.length} HTTP checker shortcode(s)`)

  // Create independent Vue app for each mount point
  mountPoints.forEach((element) => {
    try {
      const mountElementId = element.id
      
      // Create app instance
      const app = createApp(App, {
        mountElementId
      })

      // Register Ant Design Vue
      app.use(Antd)

      // Mount to specific element
      app.mount(`#${mountElementId}`)

      console.log(`[Conflated Domains] HTTP Checker app mounted to #${mountElementId}`)
    } catch (error) {
      console.error(`[Conflated Domains] Failed to mount HTTP Checker app to #${element.id}:`, error)
      
      // Display user-friendly error message in mount point
      element.innerHTML = `
        <div style="padding: 1rem; background: #fee; border: 1px solid #fcc; border-radius: 4px; color: #c00;">
          <strong>HTTP Checker Unavailable</strong>
          <p>Unable to load the HTTP status checker tool. Please refresh the page or contact support if the problem persists.</p>
        </div>
      `
    }
  })
}
